import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    HostBinding,
    HostListener,
    OnDestroy,
    OnInit,
    inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

import { PrettyUrlsConfig } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { RacingUrlParam } from '@frontend/sports/racing/feature/models';
import { Subscription } from 'rxjs';

import { GreyhoundService, RaceModel } from '../../../common/greyhound-service';

@Component({
    selector: 'ms-meeting-switcher',
    templateUrl: './meeting-switcher.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MeetingSwitcherComponent implements OnInit, OnDestroy {
    @HostBinding('class') className = 'meeting-switcher';
    dayOfRaces: RaceModel[];
    routerEventsSubscription: Subscription;
    readonly sport: SportConstant = SportConstant.Greyhounds;
    private readonly destroyRef = inject(DestroyRef);
    constructor(
        private greyhoundService: GreyhoundService,
        private changeDetection: ChangeDetectorRef,
        private routerEvents: RouterEventsService,
        private urlConfig: PrettyUrlsConfig,
        private router: Router,
    ) {}

    @HostListener('click', ['$event'])
    click(event: Event): void {
        event.stopPropagation();
    }

    sortSwitcher(url: string) {
        if (this.dayOfRaces) {
            const tomorrow = this.urlConfig.translations[RacingUrlParam.Tomorrow];
            const today = this.urlConfig.translations[RacingUrlParam.Today];
            const nextrace = this.urlConfig.translations[RacingUrlParam.NextRaces];
            const pattern = new RegExp('-' + SportConstant.Greyhounds);
            if (pattern.test(url) && url.includes(nextrace) && this.dayOfRaces[0].day !== today) {
                this.dayOfRaces = this.dayOfRaces.sort((a, b) => a.day.localeCompare(b.day));
            }
            if (pattern.test(url) && (url.includes(tomorrow) || url.includes(today))) {
                this.dayOfRaces = url.includes(tomorrow)
                    ? this.dayOfRaces.sort((a, b) => b.day.localeCompare(a.day))
                    : this.dayOfRaces.sort((a, b) => a.day.localeCompare(b.day));
            }

            if (pattern.test(url) && !url.includes(tomorrow) && !url.includes(today) && !url.includes(nextrace)) {
                const match = url.match(/\d{3,}/g);
                const fixtureId = match ? match.pop() : '';
                const isSorted = this.dayOfRaces[0].dayRaceModel.fixtures.some((f) => f.fixtureId === fixtureId);
                if (!isSorted) this.dayOfRaces = this.dayOfRaces.sort((a, b) => a.day.localeCompare(b.day));
            }
            this.changeDetection.markForCheck();
        }
    }

    ngOnDestroy() {
        this.routerEventsSubscription?.unsubscribe();
    }

    ngOnInit(): void {
        this.routerEventsSubscription = this.routerEvents.currentRoutesRecognized.subscribe((event) => {
            if (event) {
                const url = event.urlAfterRedirects || event.url || this.router.url;
                this.sortSwitcher(url);
            }
        });

        this.greyhoundService.getAllMeetings$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
            this.dayOfRaces = data;
            this.sortSwitcher(this.router.url);
            this.changeDetection.markForCheck();
        });
    }
}
